export default __webpack_public_path__ + "static/Principle-vendor-dark-74dfed9dd7f984ba8e1681cf449809b5.png";